'use strict';
var parent = require('../es/parse-int');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/parse-int.js
// module id = 780
// module chunks = 13